import PropTypes from 'prop-types';
import React from 'react';

import SubscriptionCancellationModal from './SubscriptionCancellationModal';

class SubscriptionCancellationModalContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      didCancelSubscription: false,
      didCancelSubscriptionFail: false,
      isCancellationInProgress: false,
    };
    this.handleCancellationRequest = this.handleCancellationRequest.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleCancellationRequest() {
    this.setState({ isCancellationInProgress: true });

    Promise.resolve(this.props.onCancellationRequest())
      .then(() => {
        // Legacy behaviour: if the client is a trial, close the modal right after confirmation:
        if (this.props.isTrialUser) {
          this.props.onClose();
          return;
        }
        this.setState({
          didCancelSubscription: true,
          isCancellationInProgress: false,
        });
      })
      .catch(() => {
        this.setState({
          didCancelSubscriptionFail: true,
          isCancellationInProgress: false,
        });
      });
  }

  handleClose() {
    if (!this.state.isCancellationInProgress) {
      this.props.onClose();
    }
  }

  render() {
    const { didCancelSubscription, didCancelSubscriptionFail, isCancellationInProgress } =
      this.state;

    return (
      <SubscriptionCancellationModal
        disablePrimaryButton={isCancellationInProgress}
        disableSecondaryButton={isCancellationInProgress || didCancelSubscriptionFail}
        isSubscriptionCancelled={didCancelSubscription}
        onClose={this.handleClose}
        onPrimaryButtonClick={this.handleCancellationRequest}
        onSecondaryButtonClick={this.handleClose}
      />
    );
  }
}

SubscriptionCancellationModalContainer.propTypes = {
  isTrialUser: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCancellationRequest: PropTypes.func.isRequired,
};

export default SubscriptionCancellationModalContainer;
